function sortByRecentDate<T>(arr: T[], dateKey: keyof T): T[] {
    return [...arr].sort((a, b) => {
      const dateA = new Date(a[dateKey] as unknown as string);
      const dateB = new Date(b[dateKey] as unknown as string);
  
      return dateB.getTime() - dateA.getTime(); // Sort in descending order (most recent first)
    });
  }

  export default sortByRecentDate;